var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"d-flex align-items-center",class:_vm.statusClassType(_vm.status)},[_c('i',{class:_vm.statusIcon(_vm.status),staticStyle:{"margin-right":"5px"}}),_vm._v(" "+_vm._s(_vm.statusName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }